import {join as types} from '../actions/actiontypes'
import formReducer from './formReducer'

const joinReducer = formReducer(types)

export {joinReducer}
